module.exports = __webpack_public_path__ + "img/item5-3m.981a3d3a.jpg";